<template>
  <div>
    <!-- Snackbar 佇列 -->
    <v-snackbar
      v-for="(snack, index) in snackbars"
      :key="snack.id"
      :value="true"
      :color="snack.color"
      :timeout="snack.timeout"
      :style="{ marginBottom: `${index * 64}px` }"
      bottom
      right
      @input="handleSnackbarClose(snack.id)"
    >
      <v-icon left dark>{{ iconForType(snack.type) }}</v-icon>
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="handleSnackbarClose(snack.id)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Dialog（alert 或 confirm） -->
    <v-dialog v-if="dialog" :value="true" persistent max-width="400">
      <v-card class="text-pre-line">
        <v-card-title class="text-center justify-center">{{ dialog.message }}</v-card-title>
        <v-card-actions class="justify-center">
          <v-btn
            v-if="dialog.mode === 'confirm'"
            text
            @click="handleCancel"
          >{{ dialog.cancelText }}</v-btn>
          <v-btn
            color="primary"
            :to="dialog.to || undefined"
            @click="handleConfirm"
          >{{ dialog.confirmText }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

const ICON_MAP = {
  success: 'mdi-check-circle',
  error: 'mdi-alert-circle',
  warning: 'mdi-alert',
  info: 'mdi-information',
}

export default {
  name: 'NotificationSystem',
  computed: {
    ...mapGetters('notify', ['snackbars', 'dialog']),
  },
  methods: {
    ...mapMutations('notify', ['removeSnackbar', 'clearDialog']),
    iconForType(type) {
      return ICON_MAP[type] || ICON_MAP.info
    },
    handleSnackbarClose(id) {
      this.removeSnackbar(id)
    },
    handleConfirm() {
      const cb = this.dialog && this.dialog.onConfirm
      this.clearDialog()
      if (cb) cb()
    },
    handleCancel() {
      const cb = this.dialog && this.dialog.onCancel
      this.clearDialog()
      if (cb) cb()
    },
  },
}
</script>
